import axios from "axios";

export const vehiclesService = {
  getVehiclesService: (params) =>
    axios.get("/vehicles", { auth: true, params: { ...params } }),
  deleteVehicleService: (id) => axios.delete(`/vehicles/${id}`, { auth: true }),
  addVehicleService: (body) => axios.post("/vehicles", body, { auth: true }),
  editVehicleService: (id, body) =>
    axios.patch(`/vehicles/${id}`, body, { auth: true }),
  changeStatusVehicleService: (id, body) =>
      axios.patch(`/vehicles/${id}/status`, body, {auth: true}),

  getVehiclesLocationsService: () =>
      axios.get(`/vehicles/locations`, {auth: true}),

  getVehiclesIdlesService: (params) =>
      axios.get("/vehicles/idles", { auth: true, params: { ...params } }),
};
